<template>
  <div>
    <!-- Header -->
    <v-row class="ma-0 my-4 align-center justify-space-between">
      <h1 class="text-h5 font-weight-bold">Productos</h1>
    </v-row>

    <!-- Alert -->
    <v-alert v-if="error" type="error" dense outlined dismissible class="mb-3">{{ error }}</v-alert>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <!-- Nuevo producto -->
          <v-card-text v-if="can('products:create')" class="pb-0">
            <v-row align="center" class="ma-0">
              <v-text-field
                v-model="newNombre"
                label="Nuevo producto"
                dense
                outlined
                hide-details
                placeholder="Nombre del producto..."
                class="mr-2"
                @keyup.enter="createProducto"
              />
              <v-btn
                color="primary"
                :loading="creating"
                :disabled="!newNombre.trim()"
                @click="createProducto"
              >
                <v-icon left>mdi-plus</v-icon>Agregar
              </v-btn>
            </v-row>
          </v-card-text>

          <!-- Tabla -->
          <v-data-table
            :headers="headers"
            :items="productos"
            :loading="loading"
            hide-default-footer
            :items-per-page="-1"
            class="elevation-0 mt-2"
            no-data-text="No hay productos registrados"
          >
            <template v-slot:item.nombre="{ item }">
              <v-text-field
                v-if="editing === item.id"
                v-model="editNombre"
                dense
                outlined
                hide-details
                style="max-width: 280px"
                @keyup.enter="saveProducto(item)"
                @keyup.esc="editing = null"
              />
              <span v-else>{{ item.nombre }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <div v-if="editing === item.id" class="d-flex">
                <v-btn small color="primary" :loading="saving" @click="saveProducto(item)">
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
                <v-btn small text class="ml-1" @click="editing = null">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
              <div v-else class="d-flex">
                <v-btn v-if="can('products:update')" icon small @click="startEdit(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-if="can('products:delete')"
                  icon
                  small
                  class="ml-1"
                  @click="confirmDelete(item)"
                >
                  <v-icon small color="red lighten-1">mdi-delete-outline</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Confirm delete dialog -->
    <v-dialog v-model="deleteDialog" max-width="380" @keydown.esc="deleteDialog = false" @click:outside="deleteDialog = false">
      <v-card>
        <v-card-title class="text-h6">Eliminar producto</v-card-title>
        <v-card-text>
          ¿Estás seguro de que deseas eliminar el producto
          <strong>{{ deletingItem ? deletingItem.nombre : '' }}</strong>?
          Esta acción no se puede deshacer.
        </v-card-text>
        <v-card-actions class="pb-4 px-6">
          <v-spacer />
          <v-btn text @click="deleteDialog = false">Cancelar</v-btn>
          <v-btn color="error" :loading="deleting" @click="deleteProducto">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ProductoService from '../services/producto.service';
import { can } from '../utils/permissions';

export default {
  name: 'Productos',
  data() {
    return {
      loading: false,
      creating: false,
      saving: false,
      deleting: false,
      error: null,
      productos: [],
      newNombre: '',
      editing: null,
      editNombre: '',
      deleteDialog: false,
      deletingItem: null,
      headers: [
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: '',       value: 'actions', sortable: false, align: 'end' },
      ],
    };
  },
  mounted() {
    this.loadProductos();
  },
  methods: {
    can,
    async loadProductos() {
      this.loading = true;
      const res = await ProductoService.getAll();
      if (res.status === 'ok') this.productos = res.data;
      this.loading = false;
    },

    async createProducto() {
      const nombre = this.newNombre.trim();
      if (!nombre) return;
      this.creating = true;
      this.error = null;
      const res = await ProductoService.create(nombre);
      if (res.status === 'ok') {
        this.newNombre = '';
        await this.loadProductos();
      } else {
        this.error = 'No se pudo crear el producto.';
      }
      this.creating = false;
    },

    startEdit(item) {
      this.editing = item.id;
      this.editNombre = item.nombre;
      this.error = null;
    },

    async saveProducto(item) {
      const nombre = this.editNombre.trim();
      if (!nombre) return;
      this.saving = true;
      this.error = null;
      const res = await ProductoService.update(item.id, nombre);
      if (res.status === 'ok') {
        item.nombre = nombre;
        this.editing = null;
      } else {
        this.error = 'No se pudo actualizar el producto.';
      }
      this.saving = false;
    },

    confirmDelete(item) {
      this.deletingItem = item;
      this.deleteDialog = true;
    },

    async deleteProducto() {
      this.deleting = true;
      this.error = null;
      const res = await ProductoService.remove(this.deletingItem.id);
      if (res.status === 'ok') {
        this.productos = this.productos.filter(p => p.id !== this.deletingItem.id);
        this.deleteDialog = false;
        this.deletingItem = null;
      } else {
        this.error = 'No se pudo eliminar el producto.';
      }
      this.deleting = false;
    },
  },
};
</script>
